<template>
    <b-modal :modal-class="`modal-${variant} modal-min-btn`"
             v-model="isOpen"
             :title="title"
             hide-header-close
             centered
             :cancel-title="cancelTitle"
             @cancel="onCancelClick"
             cancel-variant="light"
             @ok="onBtnClick"
             :ok-title="okTitle"
             :ok-variant="variant"
             ref="modal"
             :ok-disabled="okDisable"
             @shown="focusInput">
        <slot>
            <div>
                <label for="input-1" v-html="message"></label>
                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <ValidationProvider :rules="fullRules"
                                        :name="name"
                                        v-slot="{ errors }" mode="eager">
                        <b-form-input id="input-dialog-1"
                                      v-model="modalValue"
                                      @keypress.native="onKeypress"
                                      trim ref="input"
                                      :state="errors.length > 0 ? false : null"
                                      :required="required">
                        </b-form-input>
                        <b-form-invalid-feedback id="input-dialog-1-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
                        <small v-if="tip" class="form-text text-muted">{{ tip }}</small>
                    </ValidationProvider>
                </ValidationObserver>
            </div>
        </slot>
    </b-modal>
</template>

<script>
export default {
    name: 'Prompt',
    props: {
        modalProps: {},
        cancelTitle: {default: 'CANCEL'},
        okTitle: {default: 'OK'},
        variant: {default: 'primary'},
        title: {default: 'Prompt'},
        message: {default: 'Enter value'},
        value: {default: ''},
        onClick: null,
        required: {default: false},
        rules: {},
        tip: {default: null},
        name: {default: ''},
    },
    data() {
        return {
            modalValue: '',
            isOpen: false
        }
    },
    computed: {
        fullRules() {
            return this.required ? {required: true, ...this.rules} : this.rules
        },
        okDisable() {
            return this.required && !this.modalValue
        }
    },
    watch: {
        open: function (newVal) {
            if (newVal) {
                this.isOpen = true;
            }
        }
    },
    methods: {
        onKeypress(e) {
            if (e.keyCode === 13) {
                e.trigger = 'ok'
                //this.$refs.modal.hide();
                this.onBtnClick(e)
            }
        },
        show() {
            this.modalValue = this.value
            return new Promise((resolve) => {
                this.resolve = resolve;
                this.$refs.modal.show();
            })
        },
        focusInput() {
            this.$refs.input.focus()
        },
        onCancelClick(e) {
            if (this.resolve) {
                e.value = this.modalValue
                this.resolve(e)
            }
        },
        async onBtnClick(e) {
            e.preventDefault()
            this.$refs.observer.reset()
            const valid = await this.$refs.observer.validate()
            if (!valid) {
                e.preventDefault()
                return
            }
            this.isOpen = false

            if (this.onClick) {
                this.onClick(e)
            }
            if (this.resolve) {
                e.value = this.modalValue
                this.resolve(e)
            }
        }
    }
}
</script>
